module.exports = __webpack_public_path__ + "img/4.23987a73.jpg";